module.exports = __webpack_public_path__ + "img/中央实验台.90774dbf.jpg";